import http from '../utils/request'

/**
 * 子流程节点配置相关 API — 对应后端 SubFlowController (/api/subflow)
 */

/** 获取可用子流程列表 */
export const listSubFlowProcesses = () => http.get('/subflow/processes')

/** 获取指定流程的节点列表 */
export const getSubFlowNodes = (processGuid) => http.get('/subflow/nodes', { params: { processGuid } })

/** 获取表的列信息 */
export const getSubFlowTableColumns = (tableName) => http.get('/subflow/table-columns', { params: { tableName } })

/** 预览流水号 */
export const previewSerialNum = (cfg) => http.post('/subflow/preview-serialnum', cfg)